import { Component, OnInit } from '@angular/core';
import { MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-evpattern',
  templateUrl: './evpattern.component.html',
  styleUrls: ['./evpattern.component.scss'],
  providers:[MasterService]
})
export class EvpatternComponent implements OnInit {

  memberdetails:any[]=[];
  classdetails:any[]=[];
  arrashead:any=[];
  arrastype:any=[];
  closeResult: string;
  classes: any=[];
  section: any=[];
  arrcourse:any=[];
  arrsubcomb:any=[];
  student:boolean=true;
  staff:boolean=false;
  memberdash:any={};
  objass:any={};
  objastype:any={};
  objfilt:any={};
  arreval:any=[];
  arrevpatern:any=[];
  arrcat:any=[{name:'Board'},{name:'Competitive'}];
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;

  constructor(private http: HttpClient, private mservice: MasterService,private modalService: NgbModal) { }

  ngOnInit(): void {

    this.masasshead();
    this.masasstype();
    this.masclass();
    this.getcourses();
    this.Getsubcomb();
  }


  masclass() {
    this.mservice.masclass()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.classes = resultArray;
            this.objfilt.clid=resultArray[0].clid;
            this.getcourses();
        },
        error => console.log("Error :: " + error)
        )
  }

  private getcourses() {

    this.mservice.getcourse()
  .subscribe((result:any) => {
  
  this.arrcourse=result;
  this.objfilt.crid=result[0].crid;
  this.Getsubcomb();
  
  }, error => {
  
  //alert('error in r');
  // this.router.navigate(['/Exprzpayresp', "Error in reading customer data"]);
  }
  );
    
    
  }

  Getsubcomb()
  {
    debugger
    this.mservice.sel_sp_exmsubcomb()
    .subscribe(
      
     resultArray =>{
      console.log('result',resultArray) ;
      this.objfilt.sucbid=resultArray[0].sucbid;
      //this.clsdate=resultArray;
      this.arrsubcomb = resultArray;
      this.getevpattern();
      },
     error => console.log("Error :: " + error)
  )
  }
   

  evalfilters()
  {
    this.masclass();
    this.getcourses();
    this.Getsubcomb();
  }
  massection() {
    this.mservice.massection()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.section = resultArray;
           
        },
        error => console.log("Error :: " + error)
        )
  }
  
  masasshead() {
    this.mservice.sel_sp_masasshead()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrashead = resultArray;
            this.objfilt.asid=resultArray[0].asid;
           // this.fmodel.assid=resultArray[0].asid;
           this.masasstype();
        },
        error => console.log("Error :: " + error)
        )
  }
  masasstype() {
    this.mservice.sel_sp_masasstype()
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrastype = resultArray;
            this.objfilt.astpid=resultArray[0].astpid;
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }

  getevpattern() {

    console.log('objfilt',this.objfilt);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    this.mservice.masevpattern(this.objfilt)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.arrevpatern = resultArray;
           // this.fmodel.asstypeId=resultArray[0].astpid;
        },
        error => console.log("Error :: " + error)
        )
  }

  includeorexclude(objdata,oprtype)
  {
    if(confirm(" Are you sure you wan't to "+oprtype))
    {
      objdata.oprtype=oprtype;
      objdata.clid=this.objfilt.clid;
      objdata.crid=this.objfilt.crid;
      objdata.sucbid=this.objfilt.sucbid;
      objdata.asid=this.objfilt.asid;
      objdata.astpid=this.objfilt.astpid;

      this.saveevpattern(objdata);
    }
  }

  updatedet(objdata,oprtype)
  {
    
      objdata.oprtype=oprtype;
      objdata.clid=this.objfilt.clid;
      objdata.crid=this.objfilt.crid;
      objdata.sucbid=this.objfilt.sucbid;
      objdata.asid=this.objfilt.asid;
      objdata.astpid=this.objfilt.astpid;
      this.saveevpattern(objdata);
    
  }

  saveevpattern(objdata) {

    console.log('objdata',objdata);
    //var pst={clid:clid,crid:crid,sucbid:sucbid,asid:asid,astpid:astpid};
    this.mservice.saveevpattern(objdata)
        .subscribe(
        resultArray => {
            console.log('getdashcounts', resultArray);
            this.getevpattern();
        },
        error => console.log("Error :: " + error)
        )
  }

}
